var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.widget,{tag:"component",attrs:{"account":_vm.account},on:{"refresh":_vm.refresh}})}
var staticRenderFns = []

export { render, staticRenderFns }